/*
 *
 * ReportsPage reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_TEAMS_WATCHER,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingTeams: true,
  teamsDrillDown: [],
  dimensions: [],
  metric: {},
  teams: [],
})

function widgetResultByTeamReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEAMS_WATCHER:
      return state
        .set("isLoadingTeams", true)
        .set("teamsDrillDown", [])
        .set("dimensions", [])
        .set("teams", [])
        .set("metric", {})

    case GET_TEAMS_SUCCESS:
      return state
        .set("isLoadingTeams", false)
        .set("teamsDrillDown", action.payload.teams_drill_down)
        .set("dimensions", action.payload.dimensions)
        .set("teams", action.payload.teams)
        .set("metric", action.payload.metric)

    case GET_TEAMS_FAILED:
      return state
        .set("isLoadingTeams", false)
        .set("teamsDrillDown", [])
        .set("dimensions", [])
        .set("teams", [])
        .set("metric", {})

    default:
      return state
  }
}

export default widgetResultByTeamReducer
